import { FinancialStatementAccount } from 'src/app/domain/financial-statement/models/common/FinancialStatementAccount';
import { GeneralLedgerTransaction } from '../../common/GeneralLedgerTransaction';

export class GeneralLedgerTransactionDTO {
  public constructor(
    public id?: number,
    public transactionDate?: Date,
    public journalEntryCode?: string,
    public description?: string,
    public comment?: string,
    public debit?: number,
    public credit?: number,
    public isManualEntry = false,
    public isMarkedForConversion = false,
    public accountId?: number,
    public contraAccountId?: number,
  ) {}

  public toEntity(account: FinancialStatementAccount, contraAccount: FinancialStatementAccount): GeneralLedgerTransaction {
    return new GeneralLedgerTransaction(
      this.id, this.transactionDate, this.journalEntryCode, account, contraAccount, this.description, this.comment,
      this.debit, this.credit, this.isManualEntry, this.isMarkedForConversion,
    );
  }

}
